// IMPORTANT: this file was generated using SVGR, please do not edit directly. Refer to the icon README.md for more info.
import type { FC } from 'react';

import { Icon, IconProps } from '../IconWrapper';

const SvgPeakUsageIcon: FC<IconProps> = ({ color, size, verticalAlign }) => (
  <Icon color={color} size={size} verticalAlign={verticalAlign}>
    <path d="M18.228 19.934H7.12q-.527 0-.758-.459t.073-.888l3.476-4.874q.237-.34.599-.524.36-.184.785-.184h2.916l4.226-4.93q.386-.447.941-.244t.555.8v9.597q0 .709-.499 1.207a1.65 1.65 0 0 1-1.207.5m-8.648-8.43-2.298 3.237a.82.82 0 0 1-.552.35.83.83 0 0 1-.637-.154.82.82 0 0 1-.35-.555.83.83 0 0 1 .155-.639l2.312-3.222A1.68 1.68 0 0 1 9.599 9.8h2.916L15.52 6.29a.8.8 0 0 1 .578-.299.84.84 0 0 1 .62.21.8.8 0 0 1 .298.578.84.84 0 0 1-.21.62l-3.006 3.508a1.54 1.54 0 0 1-.578.445 1.7 1.7 0 0 1-.708.152z" />
  </Icon>
);
export default SvgPeakUsageIcon;
SvgPeakUsageIcon.displayName = 'SvgPeakUsageIcon';
